import { ColumnDef } from "@tanstack/react-table";

import { ViewOACSchema } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { convertToCamelCase } from "src/helpers";

export const columns: ColumnDef<ViewOACSchema>[] = [
  {
    accessorKey: "_id",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Existing ToD Zones" />,
    cell({
      row: {
        original: { _id },
      },
    }) {
      return <>{convertToCamelCase(_id)}</>;
    },
  },

  {
    accessorKey: "cons_meter_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Cons. Meter Units" />,
    cell({
      row: {
        original: { cons_meter_units },
      },
    }) {
      return <>{cons_meter_units?.toFixed(2)}</>;
    },
  },
  {
    accessorKey: "gen_meter_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Gen. Meter Units " />,
    cell({
      row: {
        original: { gen_meter_units },
      },
    }) {
      return <>{gen_meter_units?.toFixed(2)}</>;
    },
  },

  {
    accessorKey: "der_gen_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Der.Gen.Units" />,
    cell({
      row: {
        original: { der_gen_units },
      },
    }) {
      return <>{der_gen_units?.toFixed(2)}</>;
    },
  },

  {
    accessorKey: "over_inj_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Over injection Units" />,
    cell({
      row: {
        original: { over_inj_units },
      },
    }) {
      return <>{over_inj_units?.toFixed(2)}</>;
    },
  },

  {
    accessorKey: "offset_banking",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Offset Banking" />,
    cell({
      row: {
        original: { offset_banking },
      },
    }) {
      return <>{offset_banking?.toFixed(2)}</>;
    },
  },

  {
    accessorKey: "adj_over_inj",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Adjusted over injection" />,
    cell({
      row: {
        original: { adj_over_inj },
      },
    }) {
      return <>{adj_over_inj?.toFixed(2)}</>;
    },
  },

  {
    accessorKey: "adj_prev_bank",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Adjusted Previous Banking" />,
    cell({
      row: {
        original: { adj_prev_bank },
      },
    }) {
      return <>{adj_prev_bank?.toFixed(2)}</>;
    },
  },
];
